import LandFeature from './LandFeature.vue';

export default LandFeature;
